/**
 * @author yueheqin
 * @date 2018/12/13
 * @project kaoshizhongxin-pc
 * @descript 用户中心
 */

export const user = [
  {
    path: '/user',
    name: 'User',
    redirect: { name: 'UserIndex' },
    component: () => import('../views/user'),
    meta: { title: '用户中心', auth: true },
    children: [
      {
        path: 'index',
        name: 'UserIndex',
        component: () => import('../views/user-index'),
        meta: { title: '用户中心', auth: true }
      },
      {
        path: 'info',
        name: 'UserInfo',
        redirect: { name: 'UserBaseInfo' },
        component: () => import('../views/user-ziliao'),
        children: [
          {
            path: 'user-info',
            name: 'UserBaseInfo',
            meta: {
              title: '用户信息',
              auth: true,
              prevRouter: {
                name: 'UserIndex',
                title: '用户中心'
              }
            },
            component: () => import('../views/user-info')
          },
          {
            path: 'edit-pwd',
            name: 'UserEditPwd',
            meta: {
              title: '用户信息',
              auth: true,
              prevRouter: {
                name: 'UserInfo',
                title: '用户中心'
              }
            },
            component: () => import('../views/user-edit-pwd')
          },
          {
            path: 'edit-photo',
            name: 'UserPhoto',
            meta: {
              title: '用户信息',
              auth: true,
              prevRouter: {
                name: 'UserInfo',
                title: '用户中心'
              }
            },
            component: () => import('../views/user-photo')
          }
        ]
      },
      {
        path: 'queslib',
        name: 'UserQues',
        meta: {
          title: '个人题库',
          auth: true,
          prevRouter: {
            name: 'User',
            title: '用户中心'
          }
        },
        component: () => import('../views/user-ques-list')
      },
      {
        path: 'doc/saved',
        name: 'UserDocSavedList',
        meta: {
          title: '存档记录',
          auth: true,
          prevRouter: {
            name: 'User',
            title: '用户中心'
          }
        },
        component: () => import('../views/user-doc-saved-list')
      },
      {
        path: 'doc/down',
        name: 'UserDocDownList',
        meta: {
          title: '下载记录',
          auth: true,
          prevRouter: {
            name: 'User',
            title: '用户中心'
          }
        },
        component: () => import('../views/user-doc-down-list')
      },
      {
        path: 'order',
        name: 'UserOrder',
        meta: {
          title: '查看订单',
          auth: true,
          prevRouter: {
            name: 'User',
            title: '用户中心'
          }
        },
        component: () => import('../views/user-order-list')
      },
      {
        path: 'quescomment',
        name: 'UserQuesComment',
        meta: {
          title: '试题评价',
          auth: true,
          prevRouter: {
            name: 'User',
            title: '用户中心'
          }
        },
        component: () => import('../views/user-ques-comment')
      }
    ]
  }
]
